/* eslint-disable max-len */

// import Helpers from '../Helpers'
import types from '../types'
// import {getSearchResults} from './getSearchResults';

// import {updateChat} from './updateChat';

export const sendPrompt = (prompt) => async (dispatch, getState) => {
  const userReducer = getState().userReducer
  const authKey = process.env.REACT_APP_AUTHKEY
  const orgId = process.env.REACT_APP_ORGID
  const uid = process.env.REACT_APP_UID
  const vkgDomain = process.env.REACT_APP_VKGDOMAIN
  const vkgId = process.env.REACT_APP_VKGID


  // Helpers.fetchPostJson(url,
  //     {
  //       authKey,
  //       orgId,
  //       uid,
  //       vkgDomain,
  //     },
  //     {
  //       vkgId,
  //       model,
  //       inputs: prompt,
  //     },
  // )

  const messageIndex = userReducer.chatFeed.length + 1
  const newChatFeed = JSON.parse(JSON.stringify(userReducer.chatFeed))
  newChatFeed.push({'type': 'question', 'text': prompt, 'isLoading': false, 'isCompleted': false})

  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  const messageCutoff = process.env.REACT_APP_MESSAGE_CUTOFF || 30 // if REACT_APP_MESSAGE_CUTOFF isn't set limit to past 30 messages
  const messages = newChatFeed
      .filter((value, index) => (newChatFeed.length - index) <= messageCutoff)
      .map((chat, chatIndex) => {
        return `${chat.type === 'question'? '[INST]': '[/INST]'}${chat.text}\n`
      })
  const inputStr = `<s>${userReducer.promptPreamble}` + messages.join('') + '[/INST]'

  const raw = JSON.stringify({
    'vkg': {
      'url': vkgDomain,
      'vgkId': vkgId,
      'orgId': orgId,
      'authKey': authKey,
      'userId': uid,
    },
    'llm': {
      'url': 'riky-chat',
      'data': {
        'inputs': inputStr,
        'parameters': {
          'max_new_tokens': 2048, // standard HG TGI parameters
          'stop': ['</s>', '###', '\n[INST]', '\n[/INST]'],
          'temperature': 0.6,
        },
      },
    },
  });

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
    connection: 'keep-alive',
  };
  newChatFeed.push({'type': 'answer', 'text': 'Loading...', 'isLoading': true, 'isCompleted': false})
  dispatch({
    type: types.STORE_PAYLOAD,
    payload: {
      chatFeed: newChatFeed,
      chatFeedTime: Date.now(),
    },
  })
  console.log('prompt: ', prompt)
  const [response] = await Promise.all([
    // dispatch(getSearchResults(prompt, newChatFeed.length - 1, vkgId)),
    fetch(process.env.REACT_APP_BASE_URL + '/vkg-generate', requestOptions)
        .catch((error) => {
          console.log(error)
          dispatch({
            type: types.STORE_PAYLOAD,
            payload: {
              userMessage: 'Chat response failed',
              notificationType: 1,
              notificationIcon: 'warning',
            },
          })
        }),
  ])
  if (!response) {
    newChatFeed.pop()
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        chatFeed: newChatFeed,
        chatFeedTime: Date.now(),
      },
    })
    return
  }
  const respJSON = await response.json()
      .catch((error) => {
        console.log(error)
        dispatch({
          type: types.STORE_PAYLOAD,
          payload: {
            userMessage: 'Chat response processing failed',
            notificationType: 1,
            notificationIcon: 'warning',
          },
        })
      })
  if (!respJSON) {
    newChatFeed.pop()
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        chatFeed: newChatFeed,
        chatFeedTime: Date.now(),
      },
    })
    return
  }
  const generated_text = respJSON['generated_text'][0] === '\n' ? respJSON['generated_text'].slice(1) : respJSON['generated_text']

  const updatedChatFeed = JSON.parse(JSON.stringify(newChatFeed)).map((message) => {
    message['isLoading'] = false
    message['isCompleted'] = false
    return message
  })
  updatedChatFeed[messageIndex]['isCompleted'] = true
  updatedChatFeed[messageIndex]['text'] = generated_text
  // dispatch(updateChat(
  //     getState().firebaseReducer.database,
  //     context ? {text: generated_text, type: 'answer', context: context}: {text: generated_text, type: 'answer'},
  //     getState().userReducer.selectedChat,
  //     messageIndex,
  // ))
  dispatch({
    type: types.STORE_PAYLOAD,
    payload: {
      chatFeed: updatedChatFeed,
      chatFeedTime: Date.now(),
    },
  })
  // const reader = response.body.getReader();
  // newChatFeed.push({'type': 'answer', 'text': resp, 'isLoading': true, 'isCompleted': false})
  // dispatch({
  //   type: types.STORE_PAYLOAD,
  //   payload: {
  //     chatFeed: newChatFeed,
  //     chatFeedTime: Date.now(),
  //   },
  // })
  // while (true) {
  //   const {done, value} = await reader.read();
  //   if (done) {
  //     console.log(resp)
  // const updatedChatFeed = JSON.parse(JSON.stringify(getState().userReducer.chatFeed)).map((message) => {
  //   message['isLoading'] = false
  //   message['isCompleted'] = false
  //   return message
  // })
  // updatedChatFeed[messageIndex]['isCompleted'] = true
  // dispatch(updateChat(
  //     getState().firebaseReducer.database,
  //     {text: resp, type: 'answer'},
  //     getState().userReducer.selectedChat,
  //     messageIndex,
  // ))
  //     dispatch({
  //       type: types.STORE_PAYLOAD,
  //       payload: {
  //         chatFeed: updatedChatFeed,
  //         chatFeedTime: Date.now(),
  //       },
  //     })
  //     return;
  //   }
  //   // Otherwise do something here to process current chunk
  //   // const val = JSON.parse(`{${Buffer.from(value).toString('utf8')}}`)
  //   const vals = Buffer.from(value).toString('utf8').replace('\n\n', '').split('data:')
  //   // console.log(vals)
  //   for (let i = 0; i < vals.length; i++) {
  //     if (vals[i].length) {
  //       try {
  //         const parsed = JSON.parse(partialData + vals[i])
  //         const inter = parsed['token']['text']
  //         if (!parsed['generated_text']) {
  //           resp = resp + inter
  //           partialData = ''
  //           const updatedChatFeed = JSON.parse(JSON.stringify(getState().userReducer.chatFeed))
  //           updatedChatFeed[messageIndex]['text'] = resp
  //           dispatch({
  //             type: types.STORE_PAYLOAD,
  //             payload: {
  //               chatFeed: updatedChatFeed,
  //               chatFeedTime: Date.now(),
  //             },
  //           })
  //         }
  //       } catch (error) {
  //         partialData = vals[i]
  //       }
  //     }
  //   }
  // console.log(`"${Buffer.from(value).toString('utf8')}"`)
}
